import { Receipt } from '../../../types/receipts';
import { Actions, ActionTypes } from './actions';

export interface State {
    receiptId: string | null;
    receipt: Receipt | undefined;
    accountId: string;
    id: string;
    isLoading: boolean;
}

export const initialState: State = {
    receiptId: null,
    receipt: undefined,
    isLoading: false,
    accountId: '',
    id: '',
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetReceipt:
            return {
                ...state,
                isLoading: true,
                accountId: action.payload.accountId,
                id: action.payload.id,
                receiptId: action.payload.receiptId,
            };


        case ActionTypes.ReceiptResponse:
            return {
                ...state,
                receipt: action.payload.receipt,
                isLoading: false,
            };

        case ActionTypes.ClearReceipt:
            return initialState;

        default:
            return state;
    }
}

